import styled from '@emotion/styled';

export const TwentyEightDegreesTheme = styled.div`
  ${props => `
    background: ${props.theme.backgroundColor};
  `}
`;
